import { styled } from '@nx-kit/styling';
import useTranslation from 'next-translate/useTranslation';
import { LOCALES_MAP } from 'prismic/config';
import Icon from 'components/atoms/Icon/Icon';

export interface DateTimeProps {
  date: Date;
  timeslot: string;
  location?: string | null;
  house_nr?: number | null;
  locationName?: string | null;
  ort?: string | null;
}

const DateTimeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 35px;
  margin-bottom: 10px;
  width: 100%;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Item = styled.div`
  align-items: flex-start;
  display: flex;
`;

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.global.color.primary};
  margin-right: 10px;
`;

const dateOptions: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

export const DateTimeInfo: React.FC<DateTimeProps> = ({
  date,
  timeslot,
  location,
  house_nr,
  locationName,
  ort,
}) => {
  const { lang } = useTranslation('common');
  const locale = LOCALES_MAP[lang] ?? LOCALES_MAP.default;
  const formattedDate = date.toLocaleDateString(locale, dateOptions);

  const hasDetailedLocation = house_nr != null || locationName;
  const locationLabel = hasDetailedLocation
    ? house_nr != null && locationName
      ? `${house_nr} ${locationName}`
      : locationName || String(house_nr)
    : location;

  return (
    <DateTimeContainer>
      <Group>
        <Item>
          <StyledIcon name="CALENDAR" />
          <span>{formattedDate}</span>
        </Item>
        <Item>
          <StyledIcon name="CLOCK" />
          <span>{timeslot.replace(/\:/g, '.')}</span>
        </Item>
      </Group>
      {locationLabel && (
        <Group>
          <Item>
            <StyledIcon name="MAPCURSOR" />
            <div>
              <div>{locationLabel}</div>
              {ort && <div>{ort}</div>}
            </div>
          </Item>
        </Group>
      )}
    </DateTimeContainer>
  );
};
